<template>
     <v-main>

      <v-row class="d-flex justify-center align-center">
        <v-container class="container-pnr">
          <v-row>
            <v-col>
              <v-btn @click="goBack" color="duo-secondary"
                class="mr-2 mt-8">Back</v-btn>
            </v-col>
          </v-row>

          <v-row no-gutters class="custom-v-card mt-2 mr-2 mb-6 pb-6 elevation-0" align="center" justify="center" style="border-radius: 6px">
            <v-col class="d-flex flex-column">
              <v-row no-gutters class="d-flex flex-row" justify="space-between" style="padding: 24px 24px 0px 24px">
                <v-col class="px-1" style="font-family: AirNZ Sans Semibold; font-size: 18px; line-height: 21px; color: black !important">
                  <p style="font-family: AirNZ Sans Regular; font-weight: normal !important; font-size: 13px;">{{ post.creatorName }} - {{ post.createdDate }}</p>
                </v-col>
                <v-col align="right">
                  <v-icon 
                    size="18" class="ml-2" @click="showPostEdit(post)">
                    mdi-pencil
                  </v-icon>
                  <v-icon 
                    size="18" class="ml-2 icon-tm-delete" @click="showDeletePost(post)">
                  </v-icon>
                </v-col>
              </v-row>
              <v-row no-gutters class="d-flex flex-row" justify="space-between" style="padding: 0px 24px 15px 24px">
                <v-col class="px-1" style="font-family: AirNZ Sans Semibold; font-size: 26px; line-height: 21px; color: black !important">
                  {{ post.title }}
                </v-col>
              </v-row>
              <v-row no-gutters class="d-flex flex-row" justify="space-between" style="padding: 3px 24px 0px 24px">
                <v-col class="px-1" style="font-family: AirNZ Sans Regular; font-size: 18px; line-height: 21px; color: black !important">
                  <p style="font-family: AirNZ Sans Regular; font-weight: normal !important; font-size: 16px;">
                    <span v-html="post.content"></span>
                  </p>
                </v-col>
              </v-row>
              <v-row no-gutters class="d-flex flex-row" justify="space-between" style="padding: 0px 24px 0px; margin-bottom: -15px">
                <v-col class="px-1" style="font-family: AirNZ Sans Regular; font-size: 18px; line-height: 21px;">
                  <v-textarea v-model="newComment" placeholder="Leave a comment" outlined :rows="2"></v-textarea>
                </v-col>
              </v-row>
              <v-row
                no-gutters
                class="d-flex flex-row"
                justify="space-between"
                align="center"
                style="padding: 0px 20px 10px 24px"
                >
                <v-col
                  class="px-1"
                  style="font-family: AirNZ Sans Regular; font-size: 18px; line-height: 21px; color: black !important"
                >
                  <p style="font-family: AirNZ Sans Regular; font-weight: normal !important; font-size: 16px;">
                  {{ commentSize }} comments
                  </p>
                </v-col>
                <v-col class="d-none d-sm-block">
                  <v-row no-gutters class="px-0" justify="end" align="center">
                  <!-- <v-btn :disabled="!($store.state.principal.role == 'super_user' || $store.state.principal.canPost)" outlined elevation="0" id="submitPnr" class="btn-enter" @click="addComment(post.id)"> -->
                  <v-btn outlined elevation="0" id="submitPnr" class="btn-comment" @click="addComment()" :disabled="!newComment || newComment.length < 3">
                    Comment
                  </v-btn>
                  </v-row>
                </v-col>
              </v-row>

              <hr v-if="commentSize > 0" style="margin: 0 auto; height: 1px; border: none; background-color: #ccc; width: 95%;">
              <!-- <pre>{{commentSize}}</pre> -->
              <!-- Comments start -->
              <v-col v-if="commentSize > 0">
                <v-row v-for="(comment) in visibleComments" :key="comment.id">
                  <v-col>
                    <v-row  no-gutters  class="d-flex flex-row" justify="space-between" style="padding: 0px 24px 0px 24px">
                      <v-col class="px-1" style="font-family: AirNZ Sans Semibold; font-size: 18px; line-height: 21px; color: black !important">
                        <p style="font-family: AirNZ Sans Regular; font-weight: normal !important; font-size: 16px;"><strong>{{ comment.creatorName }}</strong></p>
                      </v-col>
                      <v-col class="d-none d-sm-block" align="right">
                        <p style="font-family: AirNZ Sans Regular; font-weight: normal !important; font-size: 16px;">{{ comment.createdDate }}</p>
                      </v-col>
                    </v-row>
                    <v-row no-gutters class="d-flex flex-row" justify="space-between" style="padding: 0px 24px 0px 24px">
                      <v-col class="px-1" style="font-family: AirNZ Sans Semibold; font-size: 18px; line-height: 21px; color: black !important">
                        <p style="font-family: AirNZ Sans Regular; font-weight: normal !important; font-size: 16px;">
                          {{ comment.text }}
                        </p>
                      </v-col>
                      <v-col align="right">
                        <v-icon 
                          v-if="$store.state.principal.role == 'super_user'"
                          size="18" class="" @click="showCommentEdit(comment)">mdi-pencil
                        </v-icon>
                        <v-icon 
                          v-if="$store.state.principal.role == 'super_user'"
                          size="18" class="ml-2 icon-tm-delete" @click="showCommentDelete(comment)">
                        </v-icon>
                      </v-col>
                    </v-row>
                  </v-col>
                  <hr v-if="commentSize > 0" style="margin: 0 auto; height: 1px; border: none; background-color: #ccc; width: 95%;">
                </v-row>
                <v-row justify="center" class="my-8">
                  <v-btn v-if="hasMore" @click="loadMore" color="primary">
                    Load More
                  </v-btn>
                </v-row>
              </v-col>
            </v-col>
          </v-row>

        </v-container>
      </v-row>

    <v-dialog v-model="dialogCommentDelete" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Delete Comment</span>
        </v-card-title>
        <v-card-text>Are you sure you want to delete ? <p> '{{ entity.text }}' </p></v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="dialogCommentDelete = false; entity = {}">Cancel</v-btn>
          <v-btn @click="deleteComment(entity.id)" color="accent" v-if="$store.state.principal.role == 'super_user'" >Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogCommentEdit" persistent max-width="900px">
			<v-card>
				<v-card-title>
				<span class="headline">{{entity.id != null ? 'Edit' : 'Add'}} Comment</span>
				</v-card-title>
				<v-card-text>
				<v-form ref="form" style="padding: 0 40px" autocomplete="off">
          <v-textarea v-model="entity.text" placeholder="Leave a comment" outlined :rows="1"></v-textarea>
				</v-form>
				</v-card-text>
				<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn @click="dialogCommentEdit = false; entity = {}">Cancel</v-btn>
				<v-btn @click="editComment(entity)" color="primary" v-if="$store.state.principal.role == 'super_user'" >Save</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

    <v-dialog v-model="dialogDeletePost" max-width="600px">
			<v-card>
				<v-card-title>
					<span class="headline">Delete Post</span>
				</v-card-title>
				<v-card-text>Are you sure you want to delete '{{ post.title }}' ?</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="dialogDeletePost = false">Cancel</v-btn>
					<v-btn @click="deletePost" color="accent" v-if="$store.state.principal.role == 'super_user'" >Delete</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

    <v-dialog v-model="dialogPostEdit" persistent max-width="900px">
			<v-card>
				<v-card-title>
				<span class="headline">Edit Post</span>
				</v-card-title>
				<v-card-text>
				<v-form ref="form" style="padding: 0 40px" autocomplete="off">
					<v-text-field
					v-model="post.title"
					label="Title*"
					></v-text-field>
					<p class="mb-2">Content</p>
					<v-text-editor v-if="dialogPostEdit" label="Content" v-model="post.content" :api-key="$tinyMceKey" :init="selectedInitEditor()"></v-text-editor>
          <p style="text-align: right; font-size: 12px; font-style: italic;">
					*) To resize an image, use the little blue squares on the corners of the image.
					</p>
				</v-form>
				</v-card-text>
				<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn @click="dialogPostEdit = false;">Cancel</v-btn>
				<v-btn @click="editPost(post)" color="primary">Save</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

  </v-main>
</template>

<style scoped>

/*  */

.hover-purple:hover {
  color: black;
}
.v-btn--text {
	text-transform: none !important;
	text-decoration: underline;
	letter-spacing: 0px;
}
.btn-new-post {
	width: 162px !important;
	height: 46px !important;
	border: 1px solid #440099;
	background-color: #440099 !important;
	border-radius: 4px;
	opacity: 1;
	color: white !important;
	text-transform: none !important;
	font-size: 17px !important;
	letter-spacing: 0px;
}
.btn-comment {
	width: 200px !important;
	height: 46px !important;
	border: 1px solid #0c0c0c;
	background-color: #0c0c0c !important;
	border-radius: 4px;
	opacity: 1;
	color: white !important;
	text-transform: none !important;
	font-size: 17px !important;
	letter-spacing: 0px;
}
.btn-comment[disabled] {
  background-color: #ccc !important;
  color: #666 !important;
  border-color: #999 !important;
  cursor: not-allowed;
}
.btn-save {
	width: 162px !important;
	height: 46px !important;
	border: 1px solid #0c0c0c;
	background-color: #0c0c0c !important;
	border-radius: 6px;
	opacity: 1;
	color: white !important;
	text-transform: none !important;
}
.btn-cancel {
	width: 162px !important;
	height: 46px !important;
	border: 1px solid black;
	border-radius: 6px;
	color: black !important;
	opacity: 1;
	text-transform: none !important;
}
.theme--light.v-label {
	color: black !important;
	font-size: 17px !important;
}
.btn-add-pnr {
	width: 40px !important;
	height: 40px !important;
	margin: 0px !important;
	background-color: #440099 !important;
	border-radius: 5px;
	color: white !important;
}
.pnr-input {
	width: 50px;
	height: 45px;
	/* padding: 5px; */
	margin: 0 3px;
	font-size: 20px;
	border-radius: 4px;
	border: 1px solid rgb(0, 0, 0);
	text-align: center;
}
.no-background-hover::before {
	background-color: transparent !important;
}
.error--text {
	font-family: "AirNZ Sans Regular", arial, sans-serif !important;
	color: #ec040f !important;
	font-size: 12px !important;
}
.reduce-box.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot,
.v-text-field.v-text-field--enclosed .v-text-field__details {
	padding: 0 0px;
	min-height: unset;
}
.reduce-box fieldset {
	width: 50px;
	height: 50px;
}
.reduce-box .v-text-field__slot {
	width: 50px;
	height: 50px;
	margin-bottom: -5px;
}
.theme--light.v-text-field--filled > .v-input__control > .v-input__slot {
	background: #c9c9c9;
}
.custom-v-card {
	box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
	border-radius: 4px;
	background-color: rgba(255, 255, 255, 0.9);
	color: rgba(0, 0, 0, 0.87);
	border-width: thin;
	max-width: 100%;
	outline: none;
	text-decoration: none;
	transition-property: box-shadow, opacity;
	overflow-wrap: break-word;
	position: relative;
	white-space: normal;
	min-height: 166px;
	opacity: 0.9;
}
.xl-add-pnr {
	position: absolute;
	top: 0;
	right: 0;
	margin: 35px 40px 0 0;
}
/* secondary */
button.duo-secondary > span {
	color: #008392;
}
button.duo-secondary:hover > span {
	color: #00626e;
}
button.duo-secondary {
	border: thin solid black !important;
	color: black !important;
}
button.duo-primary {
	border: thin solid #008392 !important;
}
button.duo-secondary .v-btn__content {
	color: black !important;
}
button.duo-secondary:hover .v-btn__content {
	color: #00626e !important;
}
button.duo-secondary:hover {
	border: thin solid #00626e !important;
}
button.duo-secondary::before {
	background-color: transparent !important;
}
.v-expansion-panel-header__icon {
	padding-right: 0px;
}
.theme--light.v-expansion-panels .v-expansion-panel-header .v-expansion-panel-header__icon .v-icon {
	color: #440099 !important;
}
.row-pnr-input {
	padding: 0 15px 0 25px;
}
/* Extra large devices (large desktops, 1200px and up) */
@media (max-width: 1200px) {
	.container-pnr {
		width: 100% !important;
	}
}
@media (max-width: 600px) {
	.theme--light.v-label {
		color: black !important;
		font-size: 14px !important;
	}
	.row-pnr-input {
		padding: 0 10px 10px 10px;
	}
	.container-pnr {
		padding: 0px 5px;
	}
	.row-pnr-head {
		padding: 20px 10px 0;
	}
}

</style>

<script>
/* eslint-disable no-console */
import axios from "axios";
import Editor from "@tinymce/tinymce-vue";
export default {
    components: {
      "v-text-editor": Editor,
    },
    data: function () {
        return {
            entity: {
              text: "",
              postId: null,
              id: null
            },
            newComment: "",
            post : {
              title: "",
              content: ""
            },
            listOfComments: [],
            visibleCount: 5,
            dialogCommentDelete: false,
            commentSize: 0,
            dialogCommentEdit: false,
            dialogDeletePost: false,
            dialogPostEdit: false,
            initEditor: {
                height: 150,
                width: '100%',
                selector: '',
                menubar: false,
                plugins: ["code", "paste", "table", "lists", "link", "textcolor" ],
                paste_as_text: true,
                fontsize_formats: "8px 9px 10px 11px 12px 13px 14px 15px 16px 17px 18px 20px 21px 22px 23px 24px 25px 26px 27px 28px 29px 30px 31px 32px 33px 34px 35px 36px",
                font_formats: "Arial=arial,helvetica,sans-serif; \
                                          Courier New=courier new,courier,monospace; \
                                          Georgia=georgia,palatino; \
                                          Tahoma=tahoma,arial,helvetica,sans-serif; \
                                          Times New Roman=times new roman,times; \
                                          Verdana=verdana,geneva;",
                    //       toolbar:
                    // "code undo redo | fontsizeselect | fontselect | bold italic underline forecolor backcolor | table | \
                    //                   alignleft aligncenter alignright alignjustify | \
                    //                   bullist numlist outdent indent | link | removeformat | pastetext | help"
                    toolbar:
                    "undo redo | fontsizeselect | fontselect | bold italic underline forecolor backcolor | \
                                      alignleft aligncenter alignright alignjustify | \
                                      link"
            },
        }
    },
    computed: {
      visibleComments() {
        return this.listOfComments.slice(0, this.visibleCount);
      },
      hasMore() {
        return this.visibleCount < this.listOfComments.length;
      }
    },
     mounted: function() {
      this.getPost(); 
      this.getListOfComment();
    },
    methods: {
      loadMore() {
        this.visibleCount += 5;
      },
      selectedInitEditor() {
        return this.$root.copyWith({ 
          height: 300,
          // toolbar: 'undo redo | fontsizeselect fontselect | bold italic underline | forecolor backcolor removeformat | table | alignleft aligncenter alignright alignjustify | bullist numlist | link image media pastetext',
          toolbar: 'undo redo | fontsizeselect fontselect | bold italic underline | forecolor backcolor removeformat | alignleft aligncenter alignright alignjustify | link image media',
          // plugins: 'image media link table lists charmap paste',
          plugins: 'image link paste',
          file_picker_types: 'image',
          file_picker_callback: function (callback, value, meta) {
          if (meta.filetype === 'image') {
            const input = document.createElement('input')
            input.setAttribute('type', 'file')
            input.setAttribute('accept', 'image/jpeg, image/jpg, image/png, image/gif, image/bmp')

            input.onchange = function () {
            const file = this.files[0]
            const reader = new FileReader()

            reader.onload = function () {
              const base64 = reader.result
              callback(base64, { title: file.name })
            }

            reader.readAsDataURL(file)
            }

            input.click()
          }
          },
        }, 
          this.initEditor);
      },
        editPost(post) {
          axios
            .post("/system/post/edit", { entity: post })
            .then(() => {
                this.dialogPostEdit = false;
                // this.post.content = "";
                // this.post.title = "";
                // this.post.postId = null
                // this.entity.id = null
                this.getListOfComment();
            });
        },
        showPostEdit(post) {
          this.dialogPostEdit = true;
          this.post = post;
        },
        deletePost() {
          axios
            .post("/system/post/delete", { id: this.post.id })
            .then(() => {
              this.dialogDeletePost = false;
              this.post = {}
              this.$router.push({path: "/administration/post/"});
            })
            .catch(() => {});
          
        },
        showDeletePost(item) {
          this.post = item;
          this.dialogDeletePost = true;
        },
        editComment(comment) {
          axios
            .post("/system/comment/edit", { entity: comment })
            .then(() => {
                this.dialogCommentEdit = false;
                this.entity.text = "";
                this.entity.postId = null
                this.entity.id = null
                this.getListOfComment();
            });
        },
        showCommentEdit(comment) {
          this.dialogCommentEdit = true;
          this.entity = comment;
        },
        deleteComment(commentId) {
          axios
            .post("/system/comment/delete", { id: commentId })
            .then(() => {
                this.dialogCommentDelete = false;
                this.getListOfComment();
            });
        },
        showCommentDelete(comment) {
          this.dialogCommentDelete = true;
          this.entity.id = comment.id;
          this.entity.text = comment.text;
        },
        addComment() {

          this.entity.text = this.newComment;
          this.entity.postId = this.$route.params.id;
          axios
            .post("/system/comment/add", { entity: this.entity })
            .then(() => {
                this.newComment = "";
                this.entity.text = null
                this.entity.postId = null
                this.entity.id = null
                this.getListOfComment();
            });
        },
        goBack() {
          if (this.$route.path !== '/administration/post/') {
            this.$router.push('/administration/post/')
          }

        },
        getPost() {
          axios
              .post("/system/post", { id: this.$route.params.id })
              .then((response) => {
                  this.post = response.data;
              });
        },
        getListOfComment() {
          axios
              .post("/system/comment/list", { postId: this.$route.params.id })
              .then((response) => {
                  this.listOfComments = response.data;
                  this.commentSize = this.listOfComments.length;
              });
        }
    }
}
</script>